'use client'

import { useUserRealtimeContext } from '@/lib/contexts/UserRealtimeContext'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card'
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import styles from './portal-downloads-toggle.module.scss'
import { cn } from '@/lib/utils'

const PORTAL_URL = 'https://www.productioncrate.com/portal'

export function PortalDownloadsToggle() {
  const { state, download_method, isUpdating, setDownloadMethod } = useUserRealtimeContext()

  // Only show when Portal is detected (state !== null means Portal is connected)
  if (state === null) {
    return null
  }

  const isActive = download_method === 'portal'

  const handleToggle = async () => {
    const newMethod = isActive ? 'browser' : 'portal'
    await setDownloadMethod(newMethod)
    toast.success(newMethod === 'portal' ? 'Portal downloads enabled' : 'Portal downloads disabled')
  }

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <Button
          className={cn(styles.toggleButton, { [styles.active]: isActive })}
          type="button"
          variant="black"
          aria-pressed={isActive}
          aria-label={
            isActive ? 'Portal downloads active. Click to disable.' : 'Portal downloads inactive. Click to enable.'
          }
          onClick={handleToggle}
          disabled={isUpdating}
        >
          {isUpdating ? (
            <Loader2 className={cn(styles.indicator, 'tw-animate-spin')} />
          ) : (
            <span className={cn(styles.indicator, { [styles.indicatorActive]: isActive })} aria-hidden="true" />
          )}
          <span>Portal Downloads</span>
        </Button>
      </HoverCardTrigger>
      <HoverCardContent
          side="top"
          align="end"
          className={cn('tw-rounded-[7px] tw-border-0 !tw-bg-[var(--Primary)] !tw-p-3', styles.hoverCardContent)}
        >
        <div className={styles.hoverCardTitle}>
          {isActive ? 'Deactivate Portal Downloads' : 'Activate Portal Downloads'}
        </div>
        <p className={styles.hoverCardDescription}>
          Portal allows you to sort and organize your assets in automatic folders
        </p>
        <a href={PORTAL_URL} target="_blank" rel="noopener noreferrer" className={styles.hoverCardLink}>
          You can download Portal Here
        </a>
      </HoverCardContent>
    </HoverCard>
  )
}
